<template>
  <AisRefinementList
    v-auto-animate
    :attribute="filterAttribute"
    :show-more="numberOfFacetValuesToDisplay > 0"
    :show-more-limit="maximumNumberOfFacetValuesToDisplay"
    :limit="numberOfFacetValuesToDisplay"
  >
    <template
      #default="{
        items,
        refine,
        toggleShowMore,
        canToggleShowMore,
        isShowingMore,
      }"
    >
      <div v-if="!items.length" class="empty hidden"></div>
      <SingleCheckbox
        v-for="item of items"
        :key="item.value"
        :item="item"
        @checkbox-click="refine"
      />
      <ShowMoreLessFacets
        :can-toggle-show-more="canToggleShowMore"
        :is-showing-more="isShowingMore"
        class="mt-2"
        @show-more-less-toggled="toggleShowMore"
      />
    </template>
  </AisRefinementList>
</template>

<script setup lang="ts">
import { useAlgoliaCategoryStore } from '@/stores/Category/AlgoliaCategoryStore.ts';
import ShowMoreLessFacets from '@/pages/CategoryPage/Partials/Filters/ShowMoreLessFacets.vue';
import SingleCheckbox from '@/pages/CategoryPage/Partials/Filters/SingleCheckbox.vue';

export type CheckboxFilterProps = {
  filterAttribute: string;
};
defineProps<CheckboxFilterProps>();

const { numberOfFacetValuesToDisplay, maximumNumberOfFacetValuesToDisplay } =
  useAlgoliaCategoryStore();
</script>
